module.exports = function(container) {
	const registrationRadio = container.getElementsByClassName("js-registration-type");
	// const keepNumberRadio = document.getElementById("keep-number");
	// keepNumberRadio.addEventListener("change", function() {

	// 	let isNotCypriot = false;

	// 	for (let i = 0; i < registrationRadio.length; i++) {
	// 		if (registrationRadio[i].checked) {
	// 			isNotCypriot = true;
	// 		}
	// 	}

	// 	if ( isNotCypriot ) {
	// 		document.getElementById("foreign-id-device-modal")
	// 				.classList.add("active");
	// 	}
	// });

	for (let i = 0; i < registrationRadio.length; i++) {
		registrationRadio[i].addEventListener("change", function() {

			// if (keepNumberRadio.checked) {
				document.getElementById("foreign-id-device-modal")
					.classList.add("active");
			// }
		});
	}
}